import React from 'react';
import useMediaQuery from "@mui/system/useMediaQuery";
import {Typography, useTheme} from "@mui/joy";
import Dialog from "@mui/material/Dialog";
import {BasicModalContent} from "@dreebit-registry/vsm-microservice-components";
import {resolveErrorMessage} from "../../utils/resolveErrorMessage";
import {useTranslation} from "react-i18next";
import {useMutation, useQuery} from "@apollo/client";
import {toast} from "react-toastify";
import _ from "lodash";
import InstalledBaseTDAForm from "../InstalledBaseTDAForm";
import {ToastMessageTDAs} from "../../graphql/queries/toastMessageTDAs";
import {UpdateToastMessage} from "../../graphql/mutations/updateToastMessage";
import {sanitizeToastMessageInput} from "./sanitizeToastMessageInput";

interface Props {
    open: boolean,
    toastMessageId: string,
    onClose?: () => void,
}

const UpdateSystemAnnouncementModal = ({onClose, toastMessageId, open}: Props) => {
    const theme = useTheme();
    const isFullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const {t} = useTranslation();

    const [updateToastMessageMutation] = useMutation(UpdateToastMessage);

    const {data} = useQuery(ToastMessageTDAs, {
        variables: {
            id: toastMessageId
        },
        fetchPolicy: "network-only",
    })

    const handleSubmit = (input: any) => {
        return updateToastMessageMutation({
                variables: {
                    id: toastMessageId,
                    input: sanitizeToastMessageInput(input)
                },
                refetchQueries: ["ToastMessageList", "ActiveToastMessages"]
            }
        ).then(() => {
            if (onClose) {
                onClose();
            }
        }).catch((err) => {
            toast.error(resolveErrorMessage(err, t))
        })
    }

    const attributes = _.get(data, 'toastMessage.typeDefinitionAttributeList.typeDefinitionAttributes', [])

    return <Dialog open={open} onClose={onClose} fullScreen={isFullScreen}>
        <BasicModalContent
            onClose={onClose}
            title={<Typography level={'titleSmallLight'}>{t('Edit system announcement')}</Typography>}
        >
            <InstalledBaseTDAForm
                formStyle={{paddingTop: '0px'}}
                onSubmit={handleSubmit}
                onCancel={onClose}
                submitButtonText={t('Update')}
                attributes={attributes}
            />
        </BasicModalContent>
    </Dialog>
};

export default UpdateSystemAnnouncementModal;
